import pinyin from 'js-pinyin'

// 中文转拼音
Object.defineProperty(String.prototype, 'toPinyin', {
	writable: false,
	enumerable: false,
	configurable: true,
	value: function (first: boolean) {
		let str = this
		if (first) {    // 仅取首字母
			return pinyin.getCamelChars(str).replace(/\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]/g, '').toLowerCase()
		}
		// 全拼
		return pinyin.getFullChars(str).replace(/\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]/g, '').toLowerCase()
	}
})

// 字符检索 传入检索值
Object.defineProperty(String.prototype, 'filter', {
	writable: false,
	enumerable: false,
	configurable: true,
	value: function (input: string) {
		let str = this
		let en = str.toLowerCase().includes(input.toLowerCase())
		let zhFull = str.toPinyin().toLowerCase().includes(input.toLowerCase())
		let zhFirst = str.toPinyin(true).toLowerCase().includes(input.toLowerCase())
		return en || zhFull || zhFirst
	}
})

// 删除数组项
Object.defineProperty(Array.prototype, 'remove', {
	writable: false,
	enumerable: false,
	configurable: true,
	value: function (input: any) {
		if (!input) return
		let index = this.indexOf(input)
		this.splice(index, 1)
	}
})

// 替换数组项
Object.defineProperty(Array.prototype, 'replace', {
	writable: false,
	enumerable: false,
	configurable: true,
	value: function (input: any, filter: any) {		// filter 可以为函数和对象，表示查找到原数组中的替换项
		let index = -1
		if (filter instanceof Function) {
			this.some((obj: any, i: number) => {
				const result = filter(obj)
				if (!result) return false
				index = i
				return true
			})
		} else {
			index = this.indexOf(filter)
		}
		if (index === -1) return
		this.splice(index, 1, input)
	}
})

// 生成排序码
Object.defineProperty(Array.prototype, 'genSort', {
	writable: false,
	enumerable: false,
	configurable: true,
	value: function (handle: Function) {
		if (this.length === 0) return 1
		const arr = JSON.parse(JSON.stringify(this))
		const obj = arr.sort((a: any, b: any) => handle(b) - handle(a))[0]
		return handle(obj) + 1
	}
})

// 获取符合条件的第一个元素
Object.defineProperty(Array.prototype, 'first', {
	writable: false,
	enumerable: false,
	configurable: true,
	value: function (handle?: Function) {
		if (!handle) return this[0]
		const arr = this.filter((a: any) => handle(a))
		if (arr.length == 0) return null
		return arr[0]
	}
})

// 获取符合条件的最大元素
Object.defineProperty(Array.prototype, 'max', {
	writable: false,
	enumerable: false,
	configurable: true,
	value: function (handle?: Function) {
		let val: any
		this.forEach((a: any) => {
			let curVal: any
			if (!handle) curVal = a
			else curVal = handle(a)
			if (!val) {
				val = curVal
				return
			}
			if (curVal < val) return
			val = curVal
		})
		return val
	}
})

// 求和
Object.defineProperty(Array.prototype, 'sum', {
	writable: false,
	enumerable: false,
	configurable: true,
	value: function (handle: Function) {
		let total: number = 0
		this.forEach((a: number) => {
			total += handle(a)
		})
		return total
	}
})

